import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

export const adminPullRequestsQueryKey = (orgId: string) =>
  ["admin", "org", orgId, "pull-requests"] as const;

export function useAdminPullRequests(orgId: string) {
  return useQuery({
    queryKey: adminPullRequestsQueryKey(orgId),
    queryFn: () =>
      api
        .get<"/admin/:orgId/pull-requests">(`/admin/${orgId}/pull-requests`)
        .then((res) => res.data),
  });
}
